export const PSP_THUMBNAIL_DEFAULT_SIZE = 40;
